/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * A directed, qualified link from one HealthElement to another.
 *
 * Links should be created in a single direction: the reverse link can be found through a view.
 */
export class HealthElementQualifiedLink {
  constructor(json: JSON | any) {
    Object.assign(this as HealthElementQualifiedLink, json)
  }

  /**
   * The qualification of the link. Free string; using the names of LinkQualification entries is encouraged but not enforced.
   */
  type?: string
  /**
   * A caller-chosen correlation id that groups related links across entities.
   */
  associationId?: string
  /**
   * The id of the linked HealthElement.
   */
  healthElementId?: string
}
